import { SelectionChangedEvent } from 'ag-grid-community';

import { DonorSchedule } from '@/rtk-query.gql';

export const getPhysicallySelectedDonorSchedules = (
  event: SelectionChangedEvent<DonorSchedule>,
): DonorSchedule[] => {
  const selectedDonorSchedules: DonorSchedule[] = [];

  event.api.forEachNode((node) => {
    if (node.isSelected() && node.data) {
      selectedDonorSchedules.push(node.data);
    }
  });

  return selectedDonorSchedules;
};
